// Auto-generated normalizer for table: Telefonos
export function telefonosNormalize(row) {
  return {
    idTelefono: row.idTelefono ?? row.IdTelefono ?? row['IdTelefono'] ?? 0,
    idPersona: row.idPersona ?? row.IdPersona ?? row['IdPersona'] ?? 0,
    numero: row.numero ?? row.Numero ?? row['Numero'] ?? '',
    tipo: row.tipo ?? row.Tipo ?? row['Tipo'] ?? '',
    esPrincipal: row.esPrincipal ?? row.EsPrincipal ?? row['EsPrincipal'] ?? false,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
